import {useEffect, useState} from "react";
import Pagination from "../../components/Pagination";
import {errorStatusHandle} from "../../utils/error-utils";
import {LogItem, LogPanelFilter} from "../../components/logs"
import {searchLogs} from "../../services/user-master/UserUpdateHistorySearch";
import {useDocumentTitle} from "../../hooks";
import {useDispatch} from "react-redux";
import UserMasterLayout from "../../layouts/UserMasterLayout";
import {getUserHistorySearchLogSettings} from "../../api/setting/userMasterPageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {USER_MASTER_HISTORY_SEARCH} from '../../constants/routes';
import {API_DOWNLOAD_LOG_USER} from "../../constants/api";
import React from "react";
import PageAlert from "../../components/alerts/PageAlert";
import {clearButtonProcessing, resetAlert, setButtonProcessing, setHistorySearchAlertError} from "../../store/actions";
import {PageTitle} from "../../components/admin";
import {
  clearPageLoading,
  setPageLoading
} from '../../store/actions';
import {USER_MASTER_HISTORY_SEARCH_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

function UserHistorySearchLogPage() {
  useRedirectPage(USER_MASTER_HISTORY_SEARCH_PAGE);
  const dispatch = useDispatch();
  const [formError, setFormError] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [dataSearch, setDataSearch] = useState({
    username: '',
    name: '',
    start_date: '',
    end_date: '',
    page: 1,
    per_page: 10
  });
  const [resultSearch, setResultSearch] = useState([]);

  useEffect(() => {
    const response = getUserHistorySearchLogSettings();
    const pageSettings = response.data;
    dispatch(setPageSettings(pageSettings));
    dispatch(setPageLoading());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BUTTON_SEARCH_USERS = 'button__search-users';
  useEffect(() => {
    handleSubmit()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.per_page]);

  const handleSubmit = async () => {
    try {
      dispatch(setButtonProcessing(BUTTON_SEARCH_USERS));
      const response = await searchLogs(dataSearch);
      setFormError([]);
      setTotalPage(response.data.pagination.total_pages);
      setTotalCount(response.data.pagination.total_count);
      setResultSearch(response.data.logs);
      dispatch(clearPageLoading());
      dispatch(resetAlert())
    } catch (e) {
      dispatch(clearPageLoading());
      errorStatusHandle(e);
      if (e.status === 400) {
        setFormError(e.data.errors);
        dispatch(setHistorySearchAlertError(e.data));
      }
    } finally {
      dispatch(clearButtonProcessing(BUTTON_SEARCH_USERS));
    }
  };

  const handlePageChange = (page) => {
    setDataSearch(prev => ({...prev, page}));
  };

  const handlePageSizeChange = (per_page) => {
    setDataSearch(prev => ({...prev, per_page}));
  };

  const breadcrumb = getPageBreadcrumb(USER_MASTER_HISTORY_SEARCH);
  useDocumentTitle("ユーザーマスタ更新履歴検索 - ユーザーマスタ");

  return (
    <UserMasterLayout
      sidebar={true} breadcrumb={breadcrumb}
    >
      <PageTitle title="ユーザーマスタ更新履歴検索"/>
      <div className="xl:w-full w-fit xl:mr-0 mr-[24px] inline-block">
        <RedirectAlert />
        <PageAlert />
        <p className="font-light">50MB までの xlsx ファイルをダウンロードすることができます。</p>
        <LogPanelFilter formData={dataSearch} setFormData={setDataSearch} errors={formError}
                       handleSubmitSearch={handleSubmit} buttonId={BUTTON_SEARCH_USERS}/>
        <div className="machine-infor__list">
          {resultSearch.length > 0 ?
            (resultSearch.map((item, index) => (
              <LogItem key={index} item={item} apiUrl={API_DOWNLOAD_LOG_USER}/>
            ))) : (
              <p>該当する検索結果が見つかりませんでした。別の検索条件をお試しください。</p>
            )}
        </div>

        <div className="md:mt-3 xl:mt-6 max-w-[1722px]">
          <Pagination setPage={handlePageChange}
                      currentPage={dataSearch.page}
                      pageSize={dataSearch.per_page}
                      setPageSize={totalCount > 0 ? handlePageSizeChange : null}
                      showIndex={resultSearch.length > 0}
                      numPages={totalPage}
                      totalCount={totalCount}
          />
        </div>
      </div>
    </UserMasterLayout>
  );
}

export default UserHistorySearchLogPage;

